module.exports = __webpack_public_path__ + "img/album05_10.56e330fc.jpg";